<footer class="pt-16 pb-8 bg-sys-surface">
  <div class="container mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
    <!-- Brand -->
    <div>
      <h4 class="font-bold text-xl mb-2">Billytics</h4>
      <p class="text-sm">
        Keep your data alive. Turn static into strategic. From data to business intelligence.
      </p>
    </div>

    <!-- Navigation -->
    <div>
      <h5 class="font-semibold mb-3">Navigation</h5>
      <ul class="space-y-2">
        <li><a href="/#home" class="hover:underline">Home</a></li>
        <li><a href="/#features" class="hover:underline">Features</a></li>
        <li><a href="/#pricing" class="hover:underline">Pricing</a></li>
        <li><a href="/#faq" class="hover:underline">FAQ</a></li>
      </ul>
    </div>

    <!-- Legal -->
    <div>
      <h5 class="font-semibold mb-3">Legal</h5>
      <ul class="space-y-2">
        <li>
          <a routerLink="/privacy-policy" class="hover:underline">Privacy Policy</a>
        </li>
        <li>
          <a routerLink="/billytics-terms-and-conditions" class="hover:underline"
            >Terms & Conditions</a
          >
        </li>
      </ul>
    </div>

    <!-- Contact -->
    <div>
      <h5 class="font-semibold mb-3">Contact</h5>
      <p class="text-sm">
        Email: <a href="mailto:info@billytics.pro" class="hover:underline">info@billytics.pro</a>
      </p>
    </div>
  </div>

  <!-- Divider -->
  <div class="border-t mt-8 pt-6 text-center text-sm opacity-70">
    ©{{ date | date:'y'}} Billytics. All rights reserved.
  </div>
</footer>
